import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { api, asArray } from "@/lib/api";

export const FAQ = () => {
    const { t, i18n } = useTranslation();
    const [faqs, setFaqs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const lang = (i18n.language || "pt").split("-")[0];
        setLoading(true);
        api.get("/faqs", { params: { lang } })
            .then(({ data }) => { if (mounted) setFaqs(asArray(data)); })
            .catch(() => { if (mounted) setFaqs([]); })
            .finally(() => { if (mounted) setLoading(false); });
        return () => { mounted = false; };
    }, [i18n.language]);

    return (
        <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
            <div className="max-w-3xl mx-auto px-6 md:px-12">
                <div className="text-center mb-12 md:mb-16">
                    <div className="flex items-center justify-center gap-3 mb-5">
                        <span className="gold-divider" />
                        <span className="text-xs uppercase tracking-[0.24em] text-stone-500">
                            {t("faq.eyebrow")}
                        </span>
                        <span className="gold-divider" />
                    </div>
                    <h2 className="font-serif text-4xl sm:text-5xl text-stone-900 tracking-tight leading-[1.05]">
                        {t("faq.title_1")}{" "}
                        <em className="italic text-gold-deep font-normal">{t("faq.title_em")}</em>.
                    </h2>
                </div>

                {loading ? (
                    <div className="text-center text-stone-400 py-10">{t("faq.loading")}</div>
                ) : faqs.length === 0 ? (
                    <div className="text-center text-stone-400 py-10">{t("faq.empty")}</div>
                ) : (
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={f.id}
                                value={`faq-${f.id}`}
                                className="border-b border-stone-200 last:border-b-0"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="font-serif text-xl md:text-2xl text-stone-900 hover:no-underline py-6 text-left">
                                    {f.question}
                                </AccordionTrigger>
                                <AccordionContent className="text-stone-600 font-light leading-relaxed pb-7 text-base whitespace-pre-wrap">
                                    {f.answer}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                )}
            </div>
        </section>
    );
};
